export default __webpack_public_path__ + "static/media/img6.9da7fd8d.PNG";